import * as yup from "yup";
import { createValidationSchema, validate } from "@";
import type { CarouselFormValues } from "../types";

// Validation schema for the carousel-slide form
export const schema = createValidationSchema({
  title: validate("req"),
  order: validate("number"),
  image: yup.mixed().nullable(),
});

// Default values for the carousel-slide form fields
export const defaultValues: CarouselFormValues = {
  id: null,
  order: 0,
  title: null,
  image: null,
  imageUrl: null,
  isActive: true,
};
